<script>
import axios from "axios";
import appConfig from "@/app.config";
export default {
  page: {
    title: "Login ",
    meta: [{ name: "description", content: appConfig.description,  },],
  },
  data() {
    return {
      email: "",
      password: "",
      error:'',
      loader:false,
      showPassword: false,
    };
  },
  methods: {
    async login() { 
      this.loader=true;
      let formData = new FormData();
      formData.append("email", this.email);
      formData.append("password", this.password);
      let url = "/login";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          let userData=response.data.user;
          let token=response.data.token;
          axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
          localStorage.setItem('user', JSON.stringify(userData))
          localStorage.setItem('token',token);
          this.$router.push(this.$route.query.redirectFrom || {name: "dashboard",})
        } else {
          this.error=response.data.message;
        }
      })
      },
      togglePasswordVisibilty() {
      this.showPassword = !this.showPassword;
    },
  },
  mounted() {
    document.body.classList.add("auth-body-bg");
  },
  computed: {
    inputType() {
      return this.showPassword ? "text" : "password";
    },
  },
};
</script>

<template>
  <div style="background-color: aliceblue;">
    <div class="container py-5">
      <div class="row">
        <div class="col-md-4 mx-auto">
          <div class="card shadow-lg p-3">
            <div class="card-body">
              <div class="d-flex flex-column h-100">
                <div class="my-auto">
                  <div class="">
                    <span class="mt-4">
                      <img src="@/assets/images/logo.png" class="rounded-2" height="50px" />
                    </span><br>
                    <span class="mt-3 ms-2"><br><h5 class="text-success">Welcome Back !</h5> <p>Sign in to continue</p></span>
                  </div>
                  <div v-if="error" class="bg-danger text-white p-2 mt-3" style="font-size:12px">{{ error }}</div >
                  <div class="mt-2">
                    <b-form class="p-2" @submit.prevent="login">
                      <b-form-group class="mb-3" id="input-group-1" label="Email Address" label-for="input-1" >
                        <b-form-input id="input-1" v-model="email" type="email" placeholder="Enter Email Address"></b-form-input>
                      </b-form-group>
                      <b-form-group class="mb-3" id="input-group-2" label="Password" label-for="input-2">
                        <div class="d-flex">
                          <b-form-input id="input-2" v-model="password" required="" :type="inputType" placeholder="Enter password" ></b-form-input>
                          <div class="input-group-append">
                            <button class="btn btn-outline-primary" type="button" @click="togglePasswordVisibilty" >
                              <span :style="{ 'font-size': showPassword ? '15px' : '15px', }" :class="[ 'mdi', {'mdi-eye-off': !showPassword, 'mdi-eye': showPassword, }, 'toggle-password', ]" ></span>
                            </button>
                          </div>
                        </div>
                      </b-form-group>
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="remember-check"/>
                        <label class="form-check-label" for="remember-check">Remember me</label>
                      </div>
                      <div class="mt-3 d-grid">
                      <b-button type="submit" variant="success">Log In <b-spinner v-if="loader" small class="mr-1" label="Small Spinner"/></b-button>
                      </div>
                      <p class="text-center mt-3">Back to <router-link tag="a" to="/" class="fw-medium text-success"> <i class="fas fa-home"></i> Home</router-link></p>
                    </b-form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>